<div class="input-file" [class.is-dragging]="isDragging">
  @if (placeholder) {
    <span class="input-file__label">{{ placeholder }}</span>
  }
  <div class="input-file__items">
    @for (item of files; track item; let index = $index) {
      <div class="input-file__item">
        @if (item.preview) {
          <img class="input-file__preview" [src]="item.preview" alt="">
        } @else {
          <mat-icon aria-hidden="true">insert_drive_file</mat-icon>
          <span class="input-file__name">{{ item.file?.name || item.link }}</span>
        }
        <label class="input-file__replace" aria-label="החלפת קובץ">
          <mat-icon aria-hidden="true">edit</mat-icon>
          <input type="file" [accept]="fileAccept" [disabled]="disabled"
            (change)="replaceFile($any($event.target).files, index); $any($event.target).value = ''">
        </label>
        <button type="button" class="input-file__remove" (click)="removeFile(index)"
          [disabled]="disabled" aria-label="הסרת קובץ">
          <mat-icon aria-hidden="true">delete</mat-icon>
        </button>
      </div>
    }

    @if (canAddFile) {
      <label class="input-file__add"
        (drop)="drop($event)" (dragover)="dragOver($event)" (dragleave)="isDragging = false">
        <mat-icon aria-hidden="true">add_photo_alternate</mat-icon>
        <span>בחירת קבצים</span>
        <small>אפשר גם לגרור לכאן</small>
        <input type="file" [accept]="fileAccept" [multiple]="limit > 1"
        [disabled]="disabled" (change)="selectFiles($any($event.target).files); $any($event.target).value = ''">
      </label>
    }
  </div>
</div>
